import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiResponse, ApiService } from '../api.service';
import { NotificationSettings, UpdateNotificationSettingsPayload } from '../../interfaces/notification-settings';

@Injectable({
  providedIn: 'root',
})
export class NotificationSettingsService {
  private apiService = inject(ApiService);

  getNotificationSettings(): Observable<NotificationSettings> {
    return this.apiService.get<ApiResponse<NotificationSettings>>(`/v1/notifications-settings`).pipe(
      map((response) => {
        if (response.success && response.data) {
          return response.data;
        }
        throw new Error(response.message);
      })
    );
  }

  updateNotificationSettings(
    payload: UpdateNotificationSettingsPayload
  ): Observable<{ success: boolean; message?: string }> {
    return this.apiService.patch<{ success: boolean; message?: string }>('/v1/notifications-settings', payload);
  }
}
